import { faqThemeBodySchema } from "@redotech/redo-support-common/faq/faq-body-schema";
import * as z from "zod";

export const getFaqTheme = {
  name: "getFaqTheme" as const,
  input: z.object({}),
  output: z.object({ theme: z.optional(faqThemeBodySchema) }),
};
